export default __webpack_public_path__ + "static/media/card-product4.297a9770.jpg";